import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';



@Component({
    selector : 'baseAction',
    templateUrl:'containerAction.html'
})
export class BaseActionComponent implements OnInit{

    public constructor(public translate: TranslationService,public _appData : AppDataService, public fb : FormBuilder, public _companyService : CompanyService) {
    }
    public saveData(){
        let extra=''
/*        if (this._appData.questionTriggers){
            extra='question-'
        }*/
/*        else if (this._appData.npcTriggers){
            extra='npc-'
        }*/
/*        else if (this._appData.spaceTriggers){
            extra='space-'
        }
        else if (this._appData.jobTriggers){
            extra='job-'
        }*/

        if (this.level==1){
                this.processData(this._appData.action);
                let doc=document.getElementById(extra+'trigger-action-done')
                doc.click();
        }
        else{
                this.processData(this._appData.secondAction);
                document.getElementById('trigger-action-second-done').click();
        }   
        
    }
    public processData(action){}
    
    public room;
    public selectedPack
    public availablePacks;
    public level;
    public action;
    public rooms=[];
    public roomId='';
    public showRoomSelect=true;
    public selectAvailablePack(packId: string): void {
        this.selectedPack = this.availablePacks.find(pack => pack.id === packId);
        this.reloadLocalPacks(); 
    }  
    public selectRoom(roomId: string): void {
        let room = this.rooms.find(r => r.id === roomId);
        if (room){
            this._appData.room=room;
            this.room=room;
            this.showRoomSelect=true;
            this.childrenReloadData();
        }
    }
    public reload(){
        if (this.level==1){
            this.action = this._appData.action;

        }
        else{
            this.action = this._appData.secondAction;
        }
        if (this.action.param.room){
            this.roomId=this.action.param.room;
        }
        if (this._appData.room){
            this.room=this._appData.room;
            this.availablePacks=[]
            for (let pack in this._appData.room.packs){
              this.availablePacks.push(this._appData.room.packs[pack])
            }   
        } 

            this.rooms=[]
            if (this._appData.company){
                this._companyService.getRooms().where('company','==',this._appData.company.dbId).get().then(v=>{
                    v.forEach(r=>{
                        let room=r.data();
                        if (this.roomId && this.roomId==room.id){
                            room.selected=true
                            this.room=room;
                            this._appData.room=room;

                        }
                        this.rooms.push(room);
                    })
                    this.childrenReloadData();
                })
            }
            else{
                this._companyService.getRooms().where('user','==',this._appData.instagramUser.uid).get().then(v=>{
                    v.forEach(r=>{
                        let room=r.data();
                        if (this.roomId && this.roomId==room.id){
                            room.selected=true
                            this.room=room;
                            this._appData.room=room;
                        }
                        this.rooms.push(room);
                    })
                    this.childrenReloadData();
                })

            }
        

        this.childrenReloadData();
    }
    public childrenReloadData(){}
    public reloadLocalPacks(){}
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/baseAction.ts